import produce from 'immer';

const Reducer = produce((draft, action) => {
    switch (action.type) {
        case 'SET_CURRENT_SECTION':
            draft.section = action.payload.section;
            draft.content = action.payload.content;
            draft.users_response = action.payload.users_response;
            break;
        case 'SET_SUBMIT_ERRORS':
            draft.submit_errors = action.payload.errors;
            break;
        case 'CLEAR_SUBMIT_ERRORS':
            draft.submit_errors = undefined;
            break;
        case 'SET_CONNECTION_LOST':
            draft.connection_lost = action.payload.connectionLost;
            break;
        case 'SET_FORM_DATA':
            draft.testForm = {
                values: action.payload.formData
            };
            break;
        default:
            if (typeof draft == 'undefined') {
                return {};
            }
            break;
    }
});

export default Reducer;

function contains(needle, haystack)
{
    return haystack.indexOf(needle) !== -1;
}
